
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import { KEY_CLASS_KYUJITSU_TYPE, KEY_CLASS_YOUBI_TYPE } from '@/tcw/constant/KeyClass'
import BaseComponent from '@/tcw/components/BaseComponent'
import { TcwAPIDate, TcwFormDate } from '@/tcw/domain/types'
import {
  ApiGeneralObjectArrayPayload,
  ApiGeneralSinglePayload,
  ApiPayloadValueType
} from '@/tcw/api/types'

@Component
export default class KintaiCardWeekday extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected target!: ApiGeneralSinglePayload

  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected clickCard(date: Date): void {
    /** */
  }

  protected click(targetDate: TcwAPIDate): void {
    const date = this.tcw.dateOf(targetDate)
    if (date) {
      this.clickCard(date)
    }
  }

  protected youbi = ''
  protected kyujitsu = ''

  protected mounted(): void {
    this.setLabel()
  }

  protected get kintai(): ApiGeneralSinglePayload {
    return this.target.kintai as ApiGeneralSinglePayload
  }
  protected get jikan(): ApiPayloadValueType {
    return this.target.jikan
  }
  protected get koutsuhi(): ApiGeneralSinglePayload | null {
    return this.target.koutsuhi as ApiGeneralSinglePayload
  }
  protected get isToday(): boolean {
    return this.du.equalsDate(this.du.now(), new Date(this.target.day as string))
  }
  protected get errorInfo(): ApiGeneralObjectArrayPayload {
    return Array.isArray(this.target.errorInfo)
      ? (this.target.errorInfo as ApiGeneralObjectArrayPayload)
      : []
  }
  protected get hasError(): boolean {
    return this.errorInfo.some(e => e.code === 'ERROR')
  }
  protected get hasWarn(): boolean {
    return this.errorInfo.some(e => e.code === 'WARN')
  }
  protected get isPublicHoliday(): boolean {
    const kyujitsuCode = this.kintai.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isPublicHoliday(kyujitsuCode) // 休日だったら水色
  }
  protected get isPrivateHoliday(): boolean {
    const kyujitsuCode = this.kintai.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isPrivateHoliday(kyujitsuCode) // 有休だったらピンク
  }
  protected get isSpecialHoliday(): boolean {
    const kyujitsuCode = this.kintai.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isSpecialHoliday(kyujitsuCode) // 特休結婚忌引き休暇だったらオレンジ
  }
  protected get isSubstituteHoliday(): boolean {
    const kyujitsuCode = this.kintai.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isSubstituteHoliday(kyujitsuCode) // 振休だったら紫
  }
  protected get isWithoutHoliday(): boolean {
    const kyujitsuCode = this.kintai.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isWithoutHoliday(kyujitsuCode) // 欠勤無休だったら茶色
  }
  protected get isHalfHoliday(): boolean {
    const kyujitsuCode = this.kintai.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isHalfHoliday(kyujitsuCode) // 半休だったら薄いピンク
  }
  protected get isTransferHolidayOut(): boolean {
    const kyujitsuCode = this.kintai.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isTransferHolidayOut(kyujitsuCode) // 振出だったら紫
  }
  protected get isHolidayWorking(): boolean {
    const kyujitsuCode = this.kintai.kyujitsuCode
    if (typeof kyujitsuCode !== 'string') {
      return false
    }
    return this.tcw.isHolidayWorking(kyujitsuCode) // 休出だったら黄色
  }
  private get cardClass() {
    return {
      'is-today': this.isToday,
      'has-error': this.hasError,
      'has-warn': this.hasWarn,
      'is-public-holiday': this.isPublicHoliday,
      'is-private-holiday': this.isPrivateHoliday,
      'is-special-holiday': this.isSpecialHoliday,
      'is-substitute-holiday': this.isSubstituteHoliday,
      'is-without-holiday': this.isWithoutHoliday,
      'is-half-holiday': this.isHalfHoliday,
      'is-transfer-holiday-out': this.isTransferHolidayOut,
      'is-holiday-working': this.isHolidayWorking
    }
  }

  protected async setLabel(): Promise<void> {
    this.youbi = await this.codeLabel.getLabelByCode({
      keyClass: KEY_CLASS_YOUBI_TYPE,
      code: this.kintai.youbiCode as string
    })
    this.kyujitsu = await this.codeLabel.getLabelByCode({
      keyClass: KEY_CLASS_KYUJITSU_TYPE,
      code: this.kintai.kyujitsuCode as string
    })
  }

  protected outputTime(value: TcwFormDate): string {
    return this.du.convertDateToStr(value, 'HH:mm')
  }
}
